"use client";

import {ReactNode, useState} from "react";
import { SignInDialog } from "./SignInDialog";

type SignInButtonWithDialogProps = {
    label?: ReactNode;
    tooltip?: string;
    className?: string;
};

export function SignInButtonWithDialog({
                                           label = "Sign in",
                                           tooltip = "",
                                           className = "",
                                       }: SignInButtonWithDialogProps) {
    const [open, setOpen] = useState(false);

    return (
        <>
            <button
                title={tooltip}
                type="button"
                onClick={() => setOpen(true)}
                className={
                    className ||
                    "inline-flex items-center px-4 py-2 text-sm font-semibold text-white bg-brand-orange hover:opacity-90 rounded-md transition-colors"
                }
            >
                {label}
            </button>

            <SignInDialog open={open} onClose={() => setOpen(false)} />
        </>
    );
}
